import { GameLang } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/lang/GameLang";
import { FontStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/FontStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import * as PIXI from "pixi.js";
import { SlingoAnimationLandscapeProperties } from "../landscape/SlingoAnimationLandscapeProperties";
/**
 * SlingoAnimationPortraitProperties.ts
 */
export class SlingoAnimationPortraitProperties extends SlingoAnimationLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.animationProperties.position = new PIXI.Point(490, 900);
        // this.animationProperties.scale = new PIXI.Point(0.5, 0.5);
        let textPosition = new PIXI.Point(550, 600);
        let textSize = new PIXI.Point(1000, 280);
        let slingo2 = new TextFieldProperties(FontStyle.SLINGO_2_ANIMATION, textPosition, GameLang.DOUBLE, ControlConstants.CENTER);
        let slingo3 = new TextFieldProperties(FontStyle.SLINGO_3_ANIMATION, textPosition, GameLang.TRIPLE, ControlConstants.CENTER);
        let slingo4 = new TextFieldProperties(FontStyle.SLINGO_4_ANIMATION, textPosition, GameLang.QUADRUPLE, ControlConstants.CENTER);
        slingo2.size = textSize;
        slingo3.size = textSize;
        slingo4.size = textSize;
        this.amountFields.setValue(2, slingo2);
        this.amountFields.setValue(3, slingo3);
        this.amountFields.setValue(4, slingo4);
    }
}
